import { CreateDialog, CreateInDialogButton } from "@react-admin/ra-form-layout";
import { useState, useCallback } from "react";
import { Button, ReferenceField, SimpleForm, TextField, TextFieldProps, useRecordContext, useRedirect, useRefresh, useUpdate } from "react-admin";
import ClientEditBase from "./ClientEditBase";



const SpouseField = (props: TextFieldProps) => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const refresh = useRefresh();
    const [update, { isLoading, error }] = useUpdate();

    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
    const openCreateDialog = useCallback(() => {
      setIsCreateDialogOpen(true);
    }, []);
    const closeCreateDialog = useCallback(() => {
      setIsCreateDialogOpen(false);
    }, []);
    
    if (!record) return null;

    if(record.spouse_id == null){
      return(
        <>
        <Button
        label="Add"
        onClick={() => openCreateDialog()}
        size="small"
        variant="text"
        sx={{ p: 0, justifyContent: 'left'}}
        />
        <CreateDialog
          fullWidth
          maxWidth="md"
          isOpen={isCreateDialogOpen}
          open={openCreateDialog}
          close={closeCreateDialog}
          resource="clients"
          record={{ spouse_id: record?.id }}
          mutationOptions={{ onSuccess: async (response) => {
            const diff = { spouse_id: response.id };
            update(
                'clients',
                { id: record.id, data: diff, previousData: record }
            )
            .then(() => {
                setIsCreateDialogOpen(false);
            })
            .catch((e) => {
                console.log(e);
            })
                
    
          } }}
        >
          <SimpleForm>
            <ClientEditBase />
          </SimpleForm>
        </CreateDialog>
        </>
      );
    }
    return(
      <ReferenceField reference='clients' source='spouse_id' label="Spouse" link="show">
        <TextField source="name" />
      </ReferenceField>
    );

  }


  export default SpouseField;
